const SubsectionHeader = ({ subline, headline }) => {
  return (
    <div className="mb-10"> 
      {/* Divider */}
      <div className="border-t border-t-[#04405B99] w-full mb-3 pt-4"></div> 

      {/* Subline */}
      <h5 className="font-cairo font-extrabold text-[28px] leading-[32px] text-[#04405B]">
        {subline}
      </h5>

      {/* Headline */}
      <h4 className="font-cairo font-medium text-[28px] leading-[32px] text-[#02263C]">
        {headline}
      </h4>
    </div>
  );
};    
  

export { SubsectionHeader };